import { type FC } from "react";
import { type ActionProps } from "@legacy_user_frontend/components/pages/jobs/job_search_navigation/src/search_modal/src/search_modal_props";
import { isDefaultChecked } from "./modules";
import { AccordionLists } from "./ui_parts/accordion_lists";
import { ModalLink } from "./ui_parts/modal_link";
import * as styles from "./src/styles.css";

export type CityModalProps = {
  cityContents: {
    name: string;
    value: string;
    url: string;
    showLink: boolean;
    towns: {
      name: string;
      value: string;
      url: string;
      showLink: boolean;
    }[];
  }[];
  setIsAccordionOpen: React.Dispatch<React.SetStateAction<Record<number, boolean>>>;
  isAccordionOpen: Record<number, boolean>;
  dispatchFormState: React.Dispatch<ActionProps>;
  formState: Record<string, { url: string }>;
};

export const CityModal: FC<CityModalProps> = ({
  cityContents,
  setIsAccordionOpen,
  isAccordionOpen,
  dispatchFormState,
  formState,
}) => {
  const toggleAccordion = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsAccordionOpen({
      ...isAccordionOpen,
      [e.target.value]: e.target.checked,
    });
  };
  const handleOnCityStateChange = (e: React.ChangeEvent<HTMLInputElement>, url: string) => {
    if (e.target.checked) {
      dispatchFormState({
        type: "selectCities",
        value: e.target.value,
        url,
      });
    } else {
      dispatchFormState({ type: "unSelectCities", value: e.target.value });
    }
  };
  return (
    <>
      {cityContents.map(({ name, value, url, showLink, towns }, index) => {
        // 「その他」のカテゴリしかない場合
        if (cityContents.length === 1) {
          return (
            <div className={styles.bgOuter}>
              <ul className={styles.childLists}>
                <AccordionLists
                  contents={towns}
                  formState={formState}
                  checkBoxName="q[city][]"
                  changeEvent={handleOnCityStateChange}
                />
              </ul>
            </div>
          );
        }
        // 複数のカテゴリがある場合
        // 「その他」のカテゴリ以外 (ex:「23区」など)
        if (value) {
          return (
            <div className={styles.bgOuter} key={value}>
              <dt className={styles.cityParentOuter}>
                <label className={styles.cityParentLabel}>
                  <input
                    className={styles.checkBox}
                    type="checkbox"
                    value={value}
                    name="q[city][]"
                    onChange={(e) => handleOnCityStateChange(e, "")}
                    defaultChecked={isDefaultChecked(formState, value)}
                  />
                  <span>{name}</span>
                  {showLink && <ModalLink url={url} isTitleLink />}
                </label>
                <label className={styles.accordionLabel}>
                  <input
                    className={styles.cityAccordionButton}
                    type="checkbox"
                    onChange={toggleAccordion}
                    value={index}
                    name="accordion"
                    defaultChecked={isAccordionOpen[index]}
                  />
                </label>
              </dt>
              <dd className={styles.cityChildOuter({ isOpen: isAccordionOpen[index] })}>
                <ul className={styles.childLists}>
                  <AccordionLists
                    contents={towns}
                    formState={formState}
                    checkBoxName="q[city][]"
                    changeEvent={handleOnCityStateChange}
                  />
                </ul>
              </dd>
            </div>
          );
        }
        // 複数のカテゴリがある場合
        // 「その他」のカテゴリ
        return (
          <div className={styles.bgOuter} key={name}>
            <dt className={styles.cityParentOuter}>
              <label className={styles.cityParentLabel}>
                <span>{name}</span>
              </label>
              <label className={styles.accordionLabel}>
                <input
                  className={styles.cityAccordionButton}
                  type="checkbox"
                  onChange={toggleAccordion}
                  value={index}
                  name="accordion"
                  defaultChecked={isAccordionOpen[index]}
                />
              </label>
            </dt>
            <dd className={styles.cityChildOuter({ isOpen: isAccordionOpen[index] })}>
              <ul className={styles.childLists}>
                <AccordionLists
                  contents={towns}
                  formState={formState}
                  checkBoxName="q[city][]"
                  changeEvent={handleOnCityStateChange}
                />
              </ul>
            </dd>
          </div>
        );
      })}
    </>
  );
};
